export const ACCESS_DEALER = "dealer";
export const ACCESS_AGENT = "agent";
export const ACCESS_SUPERDEALER = "superdealer";
export const ACCESS_TEST = "test";
export const ACCESS_NO_USLUGI = "zeroUslugaAvailable";
export const ACCESS_CLIENT_STICKERS = "stickers";
export const ACCESS_CALL_PASSWORD_CONFIG = "callPasswordConfig";
